export default __webpack_public_path__ + "static/media/im.fb09ebd5.svg";